/* eslint-disable no-console */
import router from '../router'
import Cookies from 'js-cookie'

import Axios from 'axios'
const API_URL =  process.env.VUE_APP_API_ENDPOINT
const LOGIN_URL = API_URL + 'token/'
const USER_URL = API_URL + 'users/'
const PERM_URL = API_URL + 'perms/'


export default {

  user: {
    authenticated: false
  },


  login(context, creds, redirect) {
    /*Axios.post(LOGIN_URL, creds{
            localStorage.setItem('id_token', data.id_token)
            localStorage.setItem('access_token', data.access_token)
            localStorage.setItem('data', data)
            // eslint-disable-next-line no-console
            

          
            this.user.authenticated = true
    
            // Redirect to a specified route
            if(redirect) {
            router.go(redirect)        
            }
        })*/
    Axios.post(LOGIN_URL, creds )
      .then((response) => {
        localStorage.setItem('token', response.data.token)
        Axios.defaults.headers.common['Authorization'] = 'JWT ' + localStorage.getItem('token')
        //console.log(localStorage);
        console.log(creds)
        //console.log(response.data.user);
        this.getAuthHeader()
        this.getUserInfo(creds)
        //Axios.get(PERM_URL).then((response) => {localStorage.setItem('perms', JSON.stringify(response.data))})
        
        window.location = '#/'
        //request.headers.set('X-CSRF-TOKEN', response.data.token) 
        
        
      }, (error) => {
        alert('Niepoprawny email lub hasło!');
        
      })
      
  },
  logout() {
    localStorage.removeItem('token')
    localStorage.removeItem('perms')
    // Cookies.removeItem('csrftoken')
    this.user.authenticated = false
    Axios.defaults.headers.common['Authorization'] = ''
    router.push('/') 
  },

  checkAuth() {
    var jwt = localStorage.getItem('token')
    if (jwt) {
      this.user.authenticated = true
    } else {
      this.user.authenticated = false
    }
    return this.user.authenticated
  },
// checkAuth () {
// if (localStorage.getItem('token') !== null) {
//   store.commit('LOGIN_USER')
// } else {
//   store.commit('LOGOUT_USER')
// }
  // The object to be passed as a header for authenticated requests
  getAuthHeader() {
    console.log("'Authorization': 'JWT '" + localStorage.getItem('token'))
    return {
      'Authorization': 'JWT ' + localStorage.getItem('token')

    }
  },
  getUserInfo(creds) {
    Axios.get(USER_URL,{params: creds})
    .then((response) => {
      
      console.log(response.data)
    })
  },
  

  // getPermissions(){
  //   return {dostep: {'my_applications':1, 'substitution':1, 'accept':1, 'stats':1, 'users':1, 'submitted':1 }};
  // }//zwraca słownik z pozwoleniami (wyświetlanie menu) w zależności funkcji użytkownika
  //można skrócić, dla wszystkich: 'all, 'sub',  'stats'?
}
